module.exports = __webpack_public_path__ + "static/media/news-under16-health-coins.f26eea2f.png";